import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled, { css } from 'styled-components'

export const BookThumb = styled.img`
  filter: drop-shadow(0px 6px 10px rgba(0, 0, 0, 0.06));
  border-radius: 3px;
  height: 56px;
  width: 38px;
  @media (max-width: ${tokens.sizes.mdScreen}px) {
    border-radius: ${tokens.radius.large};
    height: 200px;
    width: 135px;
  }
`

export const ChapterName = styled.h5`
  font-family: Averta;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 30px;
  color: ${tokens.colors.black6};
  margin: 0 0 8px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media (max-width: ${tokens.sizes.mdScreen}px) {
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    color: ${tokens.colors.black6};
    text-align: center;
    margin: 4px 0 0 0;
  }
`

export const ChapterIndicator = styled.span`
  font-family: Averta;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${tokens.colors.primary};
  text-align: center;
`

export const BookName = styled.p`
  font-family: Averta;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  margin: 0;
  color: ${tokens.colors.black5};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media (max-width: ${tokens.sizes.mdScreen}px) {
    margin-top: 16px;
    font-weight: bold;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    color: ${tokens.colors.black6};
    white-space: normal;
    overflow: auto;
    text-overflow: unset;
  }
`

export const CoverContainer = styled.div`
  @media (max-width: ${tokens.sizes.mdScreen}px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: ${tokens.colors.livrosLight};
    border-radius: ${tokens.radius.xlarge};
    padding: 24px;
    aspect-ratio: 1;
    margin-bottom: 16px;
  }
`

export const TitleContainer = styled.div`
  margin-left: 16px;
  overflow: hidden;
  @media (max-width: ${tokens.sizes.mdScreen}px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
    padding: 0 16px;
  }
`

export const Container = styled.div<{ isClickable: boolean }>`
  width: 25%;
  display: flex;
  padding: 37px 0 24px 64px;
  margin-right: 50px;
  ${({ isClickable }) =>
    isClickable &&
    css`
      cursor: pointer;
      &:hover {
        ${ChapterName} {
          color: ${tokens.colors.black5};
          text-decoration: underline;
        }

        ${BookName} {
          color: ${tokens.colors.black4};
        }
      }
    `}

  @media (max-width: ${tokens.sizes.mdScreen + 1}px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0;
    margin: 0;
    flex: 1;
  }
`
